<template>
  <div class="layout-header-content">
    <!-- 头部内容 -->
    <div class="layout-header-left">
      <i class="fold-icon" :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'" @click="toggleCollapse">
      </i>
    </div>
    <div class="layout-header-right">
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
          <el-avatar :size="28" :src="avatarUrl" class="layout-header-avatar">
            {{ nickName.charAt(0) }}
          </el-avatar>
          <span class="layout-header-name">{{ nickName }}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="profile">个人中心</el-dropdown-item>
          <el-dropdown-item command="password">修改密码</el-dropdown-item>
          <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <!-- 修改密码弹窗 -->
    <change-password-dialog ref="pwdDialog" />
  </div>
</template>

<script>
import { logout } from '@/api/auth'
import ChangePasswordDialog from '@/view/profile/components/ChangePasswordDialog.vue'

export default {
  name: 'LayoutHeader',
  components: { ChangePasswordDialog },
  props: {
    isCollapse: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo || {}
    },
    nickName() {
      return this.userInfo.real_name || this.userInfo.username || '管理员'
    },
    avatarUrl() {
      const a = this.userInfo.avatar_file_id
      if (!a) return ''
      if (typeof a === 'string') return a
      return a.file_url || ''
    }
  },
  methods: {
    toggleCollapse() {
      this.$emit('toggle-collapse')
    },
    handleCommand(command) {
      if (command === 'profile') {
        this.$router.push('Profile')
      } else if (command === 'password') {
        this.$refs.pwdDialog.open()
      } else if (command === 'logout') {
        this.handleLogout()
      }
    },
    handleLogout() {
      this.$confirm('确定退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        logout().finally(() => {
          // 无论接口成功失败，都清空本地缓存并跳登录页
          this.$store.commit('user/RESET_USER')
          // hash 模式：先设置正确的 hash，再整页刷新
          // 整页刷新确保动态路由被彻底清除（vue-router 3 无法移除 addRoutes 的路由）
          window.location.hash = '#/login'
          window.location.reload()
        })
      }).catch(() => { })
    }
  }
}
</script>

<style lang="less" scoped>
.layout-header-content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .layout-header-left {
    display: flex;
    align-items: center;

    .fold-icon {
      font-size: 20px;
      cursor: pointer;
      color: #ffffff;
    }
  }

  .layout-header-right {
    .el-dropdown-link {
      display: inline-flex;
      align-items: center;
      cursor: pointer;
      color: #ffffff;
    }

    .layout-header-avatar {
      margin-right: 8px;
      background-color: #409eff;
      color: #fff;
      font-size: 14px;
    }

    .layout-header-name {
      margin-right: 4px;
    }
  }
}
</style>
